import React from 'react';

import { LazyAutocompleteFieldNotMultiple } from '@occc/ui-design-system';
import { useCanEditFormFieldsContext } from '@occc-app/App/CanEditFormFieldsContext';

import { Timezone } from './types';
import {
  mapQueryResponseToRawArray,
  mapRawTimezoneResponseItemToAutocompleteOption,
  useTimezonesQuery,
} from './utils';

import { FormInputProps } from '../../components/types';

type TimezoneAutocompleteProps = {
  name: string;
  label: string;
  inputProps?: FormInputProps;
  disabled?: boolean;
};

export const TimezoneAutocomplete: React.FC<TimezoneAutocompleteProps> = ({
  name,
  label,
  inputProps,
  disabled,
}) => {
  const { isEditable } = useCanEditFormFieldsContext();
  const isDisabled = disabled || !isEditable;

  return (
    <LazyAutocompleteFieldNotMultiple<Timezone, Timezone[]>
      name={name}
      label={label}
      disabled={isDisabled}
      useLazyQuery={useTimezonesQuery}
      mapQueryResponseToRawArray={mapQueryResponseToRawArray}
      mapRawResponseItemToAutocompleteOption={mapRawTimezoneResponseItemToAutocompleteOption}
      inputProps={{ margin: 'normal', ...inputProps }}
    />
  );
};
